// import React from 'react';
import notificationImage from '../../assets/notification.png'; // Replace with the actual path to your image

const Notification = () => {
  return (
    <div className="flex items-center justify-center rounded-lg h-screen w-full bg-gray-50 border">
      <div className="text-center">
        <div className="flex justify-center items-center w-full bg-gray-100 rounded-full">
          <img src={notificationImage} alt="Notification Icon" className="" />
        </div>
        <h2 className="text-xl font-semibold text-gray-600">No Notifications</h2>
        <p className="text-gray-500">Notification Inbox Empty</p>
      </div>
    </div>
  );
};

export default Notification;
